import { httpClient } from '@/services/http/httpClient'

type Params = {
  ideaId: string
}

export async function acceptInvite({ ideaId }: Params) {
  await httpClient.post('/ideas/idea-users/reply-invite', {
    ideaId,
    message: '', // This is a required field, but we don't have a message to send
    action: 'ACCEPT',
  })
}
